import { Cellstyle, HotCell } from "~app/common/components/hot-doc/hotdoc/cell";
import { ObjectUtils } from "~app/common/utils/object-utils";

export class HotCellNumericWithZero extends HotCell {
    value: number;

    constructor(rawvalue: number, flags?: Cellstyle, onChange?: (newValue) => void, isInteger = true) {
        super(flags, null, onChange);
        if (ObjectUtils.isNullOrUndefined(rawvalue)) {
            this.value = null;
        } else if(isInteger) {
            this.value = Math.round(rawvalue);
        } else{
            this.value = rawvalue;
        }
    }

    static format(value: number): string {
        if (ObjectUtils.isNullOrUndefined(value)) {
            return "";
        }

        const val = typeof value === "number" ? Math.round(value) : 0;
        return val.toString();
    }

    validate(value: any): boolean {
        return typeof value === "number" || !isNaN(value);
    }

    onDelete(): void {
        if (this.isReadonly || !this.validate(0)) {
            return;
        }
        this.value = 0;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(this.value, () => { }, {});
        this.onChange(changeArg);
    }

    protected genHtml(): string {
        return HotCellNumericWithZero.format(this.value);
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        td.classList.add(HotCell.hotNumber);

        if (this.value < 0) {
            td.classList.add("hot-alert");
        }

        super.applyStyle(td, cellProperties);
    }
}
